// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"03d545e2","239":"2b17afd9","833":"85a55697","977":"a7e1381c"}[chunkId] + ".chunk.js";
};